import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { setPhone } from '~/src/features/payments-abn/store/actionCreators';
import { formatValueForPhoneWithSpaces } from '~/src/helpers/phone/formatValueForPhoneWithSpaces';
import { TState } from '~/src/store';

import * as ST from './styled';

export type TField = {
    value: string,
    isValid: boolean,
}

export const INITIAL_SELECTED_VALUE = {
    value: '',
    label: '',
    isValid: false,
    isContactId: false,
};

const EMPTY_CONTACT = {
    contactId: undefined,
    type: undefined,
};

/**
 * Поле ввода номера телефона
 */
export const PhoneInput = ({ ...rest }): JSX.Element => {
    const dispatch = useDispatch();
    const currentNumber = useSelector((state: TState) => state.payment.paymentData.phone);

    const [selected, setSelected] = useState(INITIAL_SELECTED_VALUE);

    const [isStartedToChange, setIsStartedToChange] = useState(false);

    useEffect(() => {
        if (selected.value.length === 11) {
            dispatch(setPhone(selected.value));
        } else if (currentNumber) {
            dispatch(setPhone(''));
        }
    }, [selected, isStartedToChange, currentNumber]);

    const updateValidation = useCallback((value?: string) => {
        if (!value) {
            setIsStartedToChange(false);
            return;
        }
        if (value && !isStartedToChange) {
            setIsStartedToChange(true);
        }
    }, [isStartedToChange]);

    const onChangePhone = useCallback((phoneData: TField) => {
        const label = formatValueForPhoneWithSpaces({ value: phoneData.value, label: '+7' });

        setSelected({
            ...EMPTY_CONTACT,
            ...phoneData,
            label,
            isContactId: false,
        });

        updateValidation(phoneData.value);
    }, [updateValidation]);

    return (
        <FullWidthListContainer $size={4} $direction='column' {...rest}>
            <Paragraph4 $smaller={true} $color={COLORS.TextSecondary}>Телефон, к которому привязан SberPay</Paragraph4>

            <ST.InputPhone
                onChange={onChangePhone}
                type='phone'
                errorMessage='Введите номер телефона'
                placeholder='+7 999 999 99 99'
                name='phone'
                className={'ym-disable-keys'}
                isNotValid={isStartedToChange && !selected.isValid}
            />
        </FullWidthListContainer>
    );
};
